import {
  NAMED_COLORS,
  COLOR_CATEGORIES,
  COLOR_INTENSITIES,
  type Color,
  type NamedColor,
  type ColorWithIntensity,
  type ColorCategory,
  type ColorIntensity,
} from "@corca/data";

export function isNamedColor(color?: string | null): color is NamedColor {
  if (!color) {
    return false;
  }
  return (NAMED_COLORS as unknown as string[]).includes(color);
}

export function isColorWithIntensity(color?: string | null): color is ColorWithIntensity {
  if (!color) {
    return false;
  }
  const splittedColor = color.split("-");
  if (splittedColor.length === 2) {
    const [colorName, colorIntensity] = splittedColor;
    return (
      (COLOR_INTENSITIES as unknown as string[]).includes(colorIntensity) &&
      (COLOR_CATEGORIES as unknown as string[]).includes(colorName)
    );
  }
  return false;
}

export function isColor(color?: string | null): color is Color {
  return isNamedColor(color) || isColorWithIntensity(color);
}

export function mirrorColor(color: Color): Color {
  if (isNamedColor(color)) {
    const currentIndex = NAMED_COLORS.indexOf(color);
    return [...NAMED_COLORS].reverse()[currentIndex];
  }
  if (isColorWithIntensity(color)) {
    const [colorName, colorIntensity] = color.split("-") as [ColorCategory, ColorIntensity];
    const currentIndex = COLOR_INTENSITIES.indexOf(colorIntensity);
    return `${colorName}-${[...COLOR_INTENSITIES].reverse()[currentIndex]}`;
  }
  return color;
}
